import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "form-group col-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, [
  /*#__PURE__*/_createTextVNode(" Title "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_7 = {
  key: 0,
  class: "form-group col-9"
}
const _hoisted_8 = { class: "form-group col-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "notes" }, [
  /*#__PURE__*/_createTextVNode(" Notes "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_12 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewTypeahead = _resolveComponent("NewTypeahead")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_ctx.showNoteForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FormSection, {
          "application-id": _ctx.application,
          showBackground: false
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.newNote.title.$error ? '' : 'field-invalid'}`]),
                  name: "title",
                  type: "text",
                  placeholder: "Enter Title",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newNote.title) = $event)),
                  disabled: _ctx.isReadOnly,
                  maxlength: "50",
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.newNote.title.$touch && _ctx.v$.newNote.title.$touch(...args)))
                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_5), [
                  [_vModelText, _ctx.newNote.title]
                ]),
                (_ctx.v$.newNote.title.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Title is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.showTemplateTypeahead && !_ctx.isApplicationPalliative)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_NewTypeahead, {
                      "selected-option": _ctx.selectedTemplate,
                      "onUpdate:selected-option": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
                      "fetch-options": _ctx.getTemplateList,
                      placeholder: "Enter Preadmission Notes Template",
                      "search-char-limit": 3,
                      disabledProp: _ctx.isReadOnly
                    }, null, 8 /* PROPS */, ["selected-option", "fetch-options", "disabledProp"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("textarea", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.newNote.notes.$error ? '' : 'field-invalid'}`]),
                  name: "notes",
                  type: "text",
                  placeholder: "Enter Preadmission Notes",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newNote.notes) = $event)),
                  disabled: _ctx.isReadOnly,
                  maxlength: "2000",
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.newNote.notes.$touch && _ctx.v$.newNote.notes.$touch(...args)))
                }, "\r\n                        ", 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                  [_vModelText, _ctx.newNote.notes]
                ]),
                (_ctx.v$.newNote.notes.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Notes is required."))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("footer", _hoisted_12, [
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2 mb-2",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveNote()))
                    }, "Save"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary mb-2",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeNote()))
                    }, "Cancel")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-outline-primary mb-2",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeNote()))
                  }, "Close"))
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["application-id"])
      ]))
    : _createCommentVNode("v-if", true)
}